import { Axios as api } from "../config";

/**
 * API endpoints para la administración global del sistema
 * Endpoints exclusivos para Super Administradores
 */

export const systemModulesAPI = {
  /**
   * Obtener todos los módulos del sistema
   */
  getAll: (params = {}) => 
    api.get("/shared/system-modules/", { params }),

  /**
   * Obtener un módulo específico
   */
  get: (moduleId) => 
    api.get(`/shared/system-modules/${moduleId}/`),

  /**
   * Crear un nuevo módulo
   */
  create: (data) => 
    api.post("/shared/system-modules/", data),

  /**
   * Actualizar un módulo
   */
  update: (moduleId, data) => 
    api.patch(`/shared/system-modules/${moduleId}/`, data),

  /**
   * Eliminar un módulo
   */
  delete: (moduleId) => 
    api.delete(`/shared/system-modules/${moduleId}/`),

  /**
   * Activar/desactivar un módulo
   */
  toggle: (moduleId) => 
    api.post(`/shared/system-modules/${moduleId}/toggle/`),

  /**
   * Obtener configuración por nombre de módulo
   */
  getByName: (moduleName) => 
    api.get(`/shared/system-modules/by-name/${moduleName}/`),

  /**
   * Preview de migración de configuraciones de módulos
   * desde configuración del sistema a gestor de módulos.
   */
  getMigrationPreview: () =>
    api.get("/shared/system-modules/migration/preview/"),

  /**
   * Ejecutar migración de configuraciones de módulos.
   * Opcionalmente se puede enviar lista de claves a migrar.
   */
  executeMigration: (keys) =>
    api.post("/shared/system-modules/migration/execute/", { keys }),
};

export const auditLogsAPI = {
  /**
   * Obtener todos los logs de auditoría
   */
  getAll: (params = {}) => 
    api.get("/shared/global-audit-logs/", { params }),

  /**
   * Obtener un log específico
   */
  get: (logId) => 
    api.get(`/shared/global-audit-logs/${logId}/`),

  /**
   * Crear un nuevo log de auditoría
   */
  create: (data) => 
    api.post("/shared/global-audit-logs/", data),

  /**
   * Obtener resumen estadístico de logs
   */
  getSummary: () => 
    api.get("/shared/global-audit-logs/summary/"),

  /**
   * Obtener logs por usuario
   */
  getByUser: (userId, params = {}) => 
    api.get(`/shared/global-audit-logs/by-user/${userId}/`, { params }),

  /**
   * Obtener logs por sucursal
   */
  getByBranch: (branchId, params = {}) => 
    api.get(`/shared/global-audit-logs/by-branch/${branchId}/`, { params }),
};

export const globalConfigAPI = {
  /**
   * Obtener configuración global
   */
  get: () => 
    api.get("/shared/config/global/"),

  /**
   * Actualizar configuración global
   */
  update: (data) => 
    api.put("/shared/config/global/", data),
};

export const modulePlansAPI = {
  /**
   * Obtener todos los planes de módulos
   */
  getAll: (params = {}) => 
    api.get("/shared/module-plans/", { params }),

  /**
   * Obtener un plan específico
   */
  get: (planId) => 
    api.get(`/shared/module-plans/${planId}/`),

  /**
   * Crear un nuevo plan
   */
  create: (data) => 
    api.post("/shared/module-plans/", data),

  /**
   * Actualizar un plan
   */
  update: (planId, data) => 
    api.patch(`/shared/module-plans/${planId}/`, data),

  /**
   * Eliminar un plan
   */
  delete: (planId) => 
    api.delete(`/shared/module-plans/${planId}/`),
};

// Exportar todas las APIs
export default {
  systemModules: systemModulesAPI,
  auditLogs: auditLogsAPI,
  globalConfig: globalConfigAPI,
  modulePlans: modulePlansAPI,
};
